import URLConfig from '@Config/urls/url.config';
import { LinkItemProps } from '@Layouts/sidebar/AppSidebar';

const URL = URLConfig.CARD_MANAGEMENT_SYSTEM.DEBIT.GLOBAL_SETTINGS_MENU;

const GlobalSettingsMenuLink: Array<LinkItemProps> = [
  {
    name: 'Frais Divers Périodiques',
    link: URL.PERIODIC_MISCELLANEOUS_FEES,
    level: 3,
  },
  {
    name: 'Motif Statut Compte',
    link: URL.ACCOUNT_STATUS_REASON,
    level: 3,
  },
    
];

export default GlobalSettingsMenuLink;
